module.exports = __webpack_public_path__ + "img/abc.3a8df020.svg";